import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { logout } from '../../../reducers/currentUser/currentUser.actions';
import { Spinner } from '../../Spinner/Spinner';
import ConnectedLoggedInChecker from '../LoggedInChecker/LoggedInChecker';

export class Logout extends React.Component {
  componentDidMount() {
    this.props.logout();
  }

  render() {
    return (<span><Spinner /><ConnectedLoggedInChecker /></span>);
  }
}

Logout.propTypes = {
  logout: PropTypes.func.isRequired,
};

export const mapStateToProps = () => ({});

export const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Logout);



// WEBPACK FOOTER //
// ./src/components/Login/Logout/Logout.jsx